import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import MyCkeditor from '@/components/editor/MyCkeditor';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Fieldset from '@/components/ui/daisy/fieldset';
import { ImageFolderEnum } from '@/models/CkEditor';
import {
  SupportedLanguage,
  TranslatableDict,
} from '@/models/TranslatableField';

type QuestionContextFieldProps = {
  activeLanguage: SupportedLanguage;
  isActive: boolean;
};

export function QuestionContextField({
  activeLanguage,
  isActive,
}: QuestionContextFieldProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal.questionForm',
  });

  const { control } = useFormContext<{ context: TranslatableDict }>();

  return (
    <Fieldset label={t('context')}>
      <Fieldset.Label>{t('contextDescription')}</Fieldset.Label>
      <ConditionalRenderer condition={isActive}>
        <Controller
          key={activeLanguage}
          name={`context.${activeLanguage}`}
          control={control}
          render={({ field: { value, onChange } }) => (
            <MyCkeditor
              key={activeLanguage}
              content={value}
              folder={ImageFolderEnum.ACTIVITY}
              handleContentChange={onChange}
              placeholder={t('contextPlaceholder')}
            />
          )}
        />
      </ConditionalRenderer>
    </Fieldset>
  );
}
